import React from 'react';
import { NavLink } from 'react-router-dom';
// import { FaFacebookSquare, FaTwitter} from 'react-icons/fa';
import { AiFillInstagram, AiFillFacebook, AiOutlineTwitter, AiFillLinkedin } from 'react-icons/ai'
// import FBsvg from "../Img/bxl-facebook-square.svg";


export const Footer = () => {
    return (
        <>
            <footer data-aos="slide-up" data-aos-duration="1000" data-aos-once="true" data-aos-delay="200" id="footer" className="">
                <div className="container-fluid">
                    <div className="row">
                        <div className="social-links">
                            <div className="s-link">
                                <a href="https://www.facebook.com/profile.php?id=100008477040643" rel="noreferrer" target="_blank">
                                <AiFillFacebook color='var(--font-color)' size="24"/>
                                </a>
                            </div>
                            <div className="s-link">
                                <a href="https://www.instagram.com/avesh.khan_ak/?igshid=YmMyMTA2M2Y%3D" rel="noreferrer" target="_blank">
                                <AiFillInstagram color='var(--font-color)' size="24"/>
                                </a>
                            </div>
                            <div className="s-link">
                                <a href="https://twitter.com/" rel="noreferrer" target="_blank">
                                <AiOutlineTwitter color='var(--font-color)' size="24"/>
                                </a>
                            </div>
                            <div className="s-link">
                                <a href="https://www.linkedin.com/in/avesh-khan" rel="noreferrer" target="_blank">
                                <AiFillLinkedin color='var(--font-color)' size="24"/>
                                </a>
                            </div>
                        </div>
                        <div className="f-content d-flex-center">
                            <h5>&copy; 2023 Avesh Khan</h5>
                        </div>
                        <div className="pageLinks ">
                            <div className="navLinks">
                                <ul>
                                    <li className="link-background"><NavLink className="middle" exact to="/" activeClassName="Active-link">Home</NavLink>
                                    </li>
                                    <li className="link-background"><NavLink className="middle" exact to="/portfolio" activeClassName="Active-link">Portfolio</NavLink>
                                    </li>
                                    <li className="link-background"><NavLink className="middle" exact to="/about" activeClassName="Active-link">About</NavLink>
                                    </li>
                                    <li className="link-background"><NavLink className="middle" exact to="/contact" activeClassName="Active-link">Contact</NavLink>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </>
    )
}
